<template>
  <div
    v-if="inputs"
    class="measure-config-editor">
    <b-field
      class="input-field"
      label="Measure"
      :type="measureErrors.length ? 'is-danger' : ''"
      :message="measureErrorMessages">
      <CompanyMeasureRefSelect
        v-model="inputs.measure"
        :default-option="context.defaultMeasureOption" />
    </b-field>

    <MeasureConfigOptions
      v-model="inputs"
      :errors="errors"
      :context="context" />
  </div>
</template>

<script>
  import CompanyMeasureRefSelect from '@/components/reports/config/measures/CompanyMeasureRefSelect'
  import ModuleConfigMixin from '@/components/reports/config/modules/common/ModuleConfigMixin'
  import MeasureConfigOptions from '@/components/reports/config/modules/common/MeasureConfigOptions'
  import { childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'MeasureConfigEditor',
    components: {
      CompanyMeasureRefSelect,
      MeasureConfigOptions,
    },
    mixins: [ModuleConfigMixin,],
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        defaultValue: {
          measure: this.context.parentMeasure,
          is_pct_total: false,
          pct_total_dimensions: [],
        },
      }
    },
    computed: {
      measureErrors () {
        return childErrors('measure', this.errors)
      },
      measureErrorMessages () {
        if (!this.measureErrors.length) return ''
        return this.measureErrors.map(e => e.msg).join(', ')
      },
      enableFutureMeasure: {
        get () {
          return ![null, undefined,].includes(this.inputs.future_measure)
        },
        set (enableAverage) {
          if (enableAverage) {
            this.inputs.future_measure = {}
          } else {
            this.inputs.future_measure = undefined
          }
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
.benchmark-inputs {
  margin-top: 30px;
}
</style>
